import { useState } from 'react';
import SortAscIcon from '../../../../../assets/sort-asc.svg';
import SortDescIcon from '../../../../../assets/sort-desc.svg';
import { eventsTableColumns } from './EventsTableHeader.consts';
import { EventsTableHeaderProps } from './EventsTableHeader.types';

export function EventsTableHeader({
  sortBy,
  sortOrder,
  onSort,
}: EventsTableHeaderProps) {
  const [hoveredColumn, setHoveredColumn] = useState<string | null>(null);

  return (
    <thead>
      <tr className="w-full flex flex-row">
        {eventsTableColumns.map((column) => {
          const isActive = sortBy === column.sortKey;
          const isHovered = hoveredColumn === column.sortKey;
          const showIcon = column.sortable && (isActive || isHovered);

          return (
            <th
              key={column.label}
              className={`${
                column.width
              } flex items-center py-3 px-6 gap-2 bg-gray-40 text-xs font-medium tracking-wider text-gray-550 uppercase ${
                column.sortable ? 'cursor-pointer' : ''
              }`}
              onClick={() => column.sortable && onSort?.(column.sortKey!)}
              onMouseEnter={() =>
                column.sortable && setHoveredColumn(column.sortKey!)
              }
              onMouseLeave={() => setHoveredColumn(null)}
            >
              <span>{column.label}</span>
              {showIcon && (
                <img
                  src={
                    isActive && sortOrder === 'desc'
                      ? SortDescIcon
                      : SortAscIcon
                  }
                  alt="Sort"
                  className="w-4 h-4"
                />
              )}
            </th>
          );
        })}
      </tr>
    </thead>
  );
}
